import { render } from "./AddSabyIntegrationModal.vue?vue&type=template&id=42ed2be6&scoped=true"
import script from "./AddSabyIntegrationModal.vue?vue&type=script&lang=js"
export * from "./AddSabyIntegrationModal.vue?vue&type=script&lang=js"

import "./AddSabyIntegrationModal.vue?vue&type=style&index=0&id=42ed2be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ed2be6"]])

export default __exports__